import { isValidUrl } from '@core/utils';
import { UiService } from '@services/ui/ui.service';
import { AppService } from '@services/app/app.service';
import { Injectable } from '@angular/core';
import { HelpLinks } from '@core/models';

import { Subject, Observable, filter } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class HelpService {
  private event$ = new Subject<HelpLinks>();

  constructor(private appService: AppService, private uiService: UiService) {}

  observeEvent(event: string): Observable<HelpLinks> {
    return this.event$.asObservable().pipe(filter(x => x === event));
  }

  openLink(code: HelpLinks): void {
    if (this.hasValidHandler(code)) {
      this.event$.next(code);
    } else if (this.hasLinkValidScript(code)) {
      this.findFn(this.getLinkValue(code))();
    } else if (this.hasLinkValidUrl(code)) {
      this.openUrlBlank(this.getLinkValue(code));
    } else {
      this.uiService.showWarningToast(`wrn.no_${code}_available`);
    }
  }

  isLinkActive(code: HelpLinks): boolean {
    return (
      this.hasLinkValidUrl(code) ||
      this.hasLinkValidScript(code) ||
      this.hasValidHandler(code)
    );
  }

  private hasLinkValidUrl(code: HelpLinks): boolean {
    return isValidUrl(this.getLinkValue(code));
  }

  private hasLinkValidScript(code: HelpLinks): boolean {
    return typeof this.findFn(this.getLinkValue(code)) === 'function';
  }

  private getLinkValue(code: HelpLinks): string {
    const links = this.appService.getConfig().generic.helpLinks || [];
    const link = links.find(x => x[0] === code && !!x[1]);

    if (link) {
      return link[1];
    } else {
      return null;
    }
  }

  private hasValidHandler(code: HelpLinks): boolean {
    return this.getLinkValue(code)?.startsWith('handler:');
  }

  private openUrlBlank(url: string): void {
    window.open(url, '_blank');
  }

  private findFn(fnName: string): () => void {
    return (window as any)[fnName];
  }
}
